// Libs
import { createSlice } from '@reduxjs/toolkit';
import {
  getStatisticDailyLoading,
  getStatisticDashboardOverview,
  getStatisticForemanPerformance,
  getStatisticOrderDepositNotRequired,
  getStatisticOrderUnpaidDeposit,
  getStatisticOverbookingItem,
  getStatisticQuoteConverted,
  getStatisticTodaySchedule,
  getStatisticTodayTask,
} from './statisticThunk';
// Others

export interface IStatisticState {}

export const initialState: IStatisticState = {};

const statisticSlice = createSlice({
  name: 'statistic',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // GET: Get statistic today task
    builder
      .addCase(getStatisticTodayTask.pending, (_state) => {})
      .addCase(getStatisticTodayTask.fulfilled, (_state) => {})
      .addCase(getStatisticTodayTask.rejected, (_state) => {});

    // GET: Get statistic today schedule
    builder
      .addCase(getStatisticTodaySchedule.pending, (_state) => {})
      .addCase(getStatisticTodaySchedule.fulfilled, (_state) => {})
      .addCase(getStatisticTodaySchedule.rejected, (_state) => {});

    // GET: Get statistic quote converted
    builder
      .addCase(getStatisticQuoteConverted.pending, (_state) => {})
      .addCase(getStatisticQuoteConverted.fulfilled, (_state) => {})
      .addCase(getStatisticQuoteConverted.rejected, (_state) => {});

    // GET: Get statistic overbooking item
    builder
      .addCase(getStatisticOverbookingItem.pending, (_state) => {})
      .addCase(getStatisticOverbookingItem.fulfilled, (_state) => {})
      .addCase(getStatisticOverbookingItem.rejected, (_state) => {});

    // GET: Get statistic dashboard overview
    builder
      .addCase(getStatisticDashboardOverview.pending, (_state) => {})
      .addCase(getStatisticDashboardOverview.fulfilled, (_state) => {})
      .addCase(getStatisticDashboardOverview.rejected, (_state) => {});

    // GET: Get statistic order unpaid deposit
    builder
      .addCase(getStatisticOrderUnpaidDeposit.pending, (_state) => {})
      .addCase(getStatisticOrderUnpaidDeposit.fulfilled, (_state) => {})
      .addCase(getStatisticOrderUnpaidDeposit.rejected, (_state) => {});

    // GET: Get statistic order deposit not required
    builder
      .addCase(getStatisticOrderDepositNotRequired.pending, (_state) => {})
      .addCase(getStatisticOrderDepositNotRequired.fulfilled, (_state) => {})
      .addCase(getStatisticOrderDepositNotRequired.rejected, (_state) => {});

    // GET: Get statistic foreman performance
    builder
      .addCase(getStatisticForemanPerformance.pending, (_state) => {})
      .addCase(getStatisticForemanPerformance.fulfilled, (_state) => {})
      .addCase(getStatisticForemanPerformance.rejected, (_state) => {});

    // GET: Get statistic daily loading
    builder
      .addCase(getStatisticDailyLoading.pending, (_state) => {})
      .addCase(getStatisticDailyLoading.fulfilled, (_state) => {})
      .addCase(getStatisticDailyLoading.rejected, (_state) => {});
  },
});

// Action
export const statisticActions = statisticSlice.actions;

// Selectors

// Reducer
const statisticReducer = statisticSlice.reducer;
export default statisticReducer;
